export default __webpack_public_path__ + "static/media/showcase.0bfd9c58.svg";